import React, { useEffect, useState } from "react";
import { useTranslation, Trans} from "react-i18next";
import emailjs from "@emailjs/browser";
import map_primary from "../assets/images/map_primary.png";
import clock_primary from "../assets/images/clock_primary.png";
import {triggerFadeInOnScrollContact} from "../assets/js/swithalert";
import config from "../config";
import Breadcrumb from "../components/Breadcrumb";


function Contact() {

  const {t} = useTranslation();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    let errors = {};
    if (!formData.name.trim()) errors.name = t("name_required");
    if (!formData.email.trim()) errors.email = t("email_required");
    if (!/\S+@\S+\.\S+/.test(formData.email))
      errors.email = t("email_invalid");
    if (!formData.phone.trim()) errors.phone = t("phone_required");
    if (!formData.message.trim()) errors.message = t("message_required");

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setIsSubmitting(true);

    const emailParams = {
      title: "Nouvelle Demande de Contact",
      from_name: formData.name,
      from_email: formData.email,
      phone: formData.phone,
      message: formData.message,
    };

    try {
      await emailjs.send(
        "PristaneLAVERIE Email",
        "template_21l0qem",
        emailParams,
        "0gQ2r_n_o5SU5TiUB"
      );

      setSuccessMessage(t("send_contact_email_with_success"));
      setFormData({
        name: "",
        email: "",
        phone: "",
        message: "",
      });
      setErrors({});
    } catch (error) {
      console.error(t("error_when_send_contact_email"), error);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    triggerFadeInOnScrollContact();
  }, []);

  return (
    <div className="main">
        <div class="section_contact_top text-center"data-aos="">
            <Breadcrumb />
            <div class="subtitle text-start mx-4 ms-lg-5 my-5">
                <div class="rect col-sm-4 col-4 my-auto pt-sm-4 pt-4 d-none">
                <span class="bar"></span>
                <span class="bar"></span>
                <span class="bar"></span>
                <span class="bar"></span>
                </div>           
                <h2 class="text-start pt-5">{t("section_contact_top_title")}</h2>
                <h3 class="text-start"><Trans i18nKey="section_contact_top_subtitle_1"></Trans></h3>
                <h3 class="text-start">
                    <Trans i18nKey="section_contact_top_subtitle_2" 
                        values={{ brand: config.brand}}>
                    </Trans>
                </h3>
            </div>
            <div class="map-container">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2761.619646888765!2d6.236334176754651!3d46.19812708417117!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x478c6e2f3930ed7d%3A0xdd7d0607f1cbbe3a!2s41%20Rue%20du%20Chablais%2C%2074100%20Annemasse!5e0!3m2!1sen!2sfr!4v1741963560031!5m2!1sen!2sfr" width="600" height="450" style={{"border":0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>          

        </div>
        <div class="section_contact_middle" data-aos="">
            <div class="row mx-3 py-5 ms-lg-5 ps-lg-5">
                <div class="col-lg-6 left">
                    <h3 class="font-weight-bold text-8 mt-2 mb-0">{t("section_contact_middle_subtitle_1")}</h3>
                    <p class="mb-4 p1">{t("section_contact_middle_text_1")}</p>
                    <form className="contact-form" onSubmit={handleSubmit} noValidate>
                        <div className="row">
                            <div className="form-group col-lg-6">
                            <label className="form-label mb-1 text-2">{t("section_contact_middle_text_2")}</label>
                            <input className="form-control text-3 h-auto py-2" name="name" type="text" value={formData.name} onChange={handleChange} />
                            {errors.name && <small className="text-danger">{errors.name}</small>}
                            </div>
                            <div className="form-group col-lg-6">
                            <label className="form-label mb-1 text-2">{t("section_contact_middle_text_3")}</label>
                            <input className="form-control text-3 h-auto py-2" name="email" type="email" value={formData.email} onChange={handleChange} />
                            {errors.email && <small className="text-danger">{errors.email}</small>}
                            </div>
                        </div>

                        <div className="row">
                            <div className="form-group col">
                            <label className="form-label mb-1 text-2">{t("section_contact_middle_text_4")}</label>
                            <input className="form-control text-3 h-auto py-2" name="phone" type="text" value={formData.phone} onChange={handleChange} />
                            {errors.phone && <small className="text-danger">{errors.phone}</small>}
                            </div>
                        </div>

                        <div className="row">
                            <div className="form-group col">
                            <label className="form-label mb-1 text-2">{t("section_contact_middle_text_5")}</label>
                            <textarea className="form-control text-3 h-auto py-2" name="message" rows="5" value={formData.message} onChange={handleChange}></textarea>
                            {errors.message && <small className="text-danger">{errors.message}</small>}
                            </div>
                        </div>

                        <div className="row">
                            <div className="form-group col">
                            <button type="submit" className="btn-modern" disabled={isSubmitting}>
                                {isSubmitting ? t("section_contact_middle_text_6") : t("section_contact_middle_text_7")}
                            </button>
                            {successMessage && <p className="text-success mt-2">{successMessage}</p>}
                            </div>
                        </div>
                    </form>
                </div>
                <div class="col-lg-6 mt-5 mt-lg-0 right">
                    <h4><Trans i18nKey="section_contact_middle_subtitle_2"></Trans></h4>
                      <p class="d-flex">
                        <img src={map_primary} alt="Address" class="pb-0, pb-md-0 pe-0 pe-sm-1" style={{"max-height": "40px"}} />
                        <span class="pt-0 pt-md-2">
                          <Trans i18nKey="section_contact_middle_text_8" 
                              values={{ street: config.street, city: config.city}}>
                          </Trans>
                        </span>
                      </p>
                    <h4 class="mt-5"><Trans i18nKey="section_contact_middle_subtitle_3"></Trans></h4>
                    <p class="d-flex">
                        <img src={clock_primary} alt="Working hours" style={{"padding-right": "9px"}} class="pb-0, pb-md-0" />
                        <span class="pt-0 pt-md-1">
                            <Trans i18nKey="section_contact_middle_text_9" 
                                values={{opening_hours: config.opening_hours}}>
                            </Trans>
                        </span>
                    </p>
                </div>
            </div>

        </div>
    </div>

    
  );
}

export default Contact;
